import { useState } from "react";
import CaseNoWiseDrat from "./Tabs/CaseNoWiseDrat";
import DiaryNoWiseDrat from "./Tabs/DiaryNoWiseDrat";
import PartyNoWiseDrat from "./Tabs/PartyNoWiseDrat";

const DratCaseStatusParent = () => {
  const [relatedLink, setRelatedLink] = useState("DiaryNoWiseDrat");

  return (
    <>
      <div
        className="col-12 col-sm-12 col-md-12 col-lg-12 tab-one p-0"
        role="region"
        aria-label="DRAT Case Status Tabs"
      >
        <ul
          className="nav toptab-one mb-3 inner-tab mx-0"
          id="drat-tablist"
          role="tablist"
        >
          {/* --- Diary Number --- */}
          <li className="nav-item" role="presentation">
            <a
              href="#pane-diary"
              id="tab-diary"
              className={
                relatedLink === "DiaryNoWiseDrat"
                  ? "nav-link active"
                  : "nav-link"
              }
              role="tab"
              aria-controls="pane-diary"
              aria-selected={relatedLink === "DiaryNoWiseDrat"}
              data-bs-toggle="pill"
              onClick={(e) => {
                e.preventDefault();
                setRelatedLink("DiaryNoWiseDrat");
              }}
            >
              Diary Number
            </a>
          </li>

          {/* --- Case Number --- */}
          <li className="nav-item" role="presentation">
            <a
              href="#pane-case"
              id="tab-case"
              className={
                relatedLink === "CaseNoWiseDrat"
                  ? "nav-link active"
                  : "nav-link"
              }
              role="tab"
              aria-controls="pane-case"
              aria-selected={relatedLink === "CaseNoWiseDrat"}
              data-bs-toggle="pill"
              onClick={(e) => {
                e.preventDefault();
                setRelatedLink("CaseNoWiseDrat");
              }}
            >
              Case Number
            </a>
          </li>

          {/* --- Party Name --- */}
          <li className="nav-item" role="presentation">
            <a
              href="#pane-party"
              id="tab-party"
              className={
                relatedLink === "PartyNoWiseDrat"
                  ? "nav-link active"
                  : "nav-link"
              }
              role="tab"
              aria-controls="pane-party"
              aria-selected={relatedLink === "PartyNoWiseDrat"}
              data-bs-toggle="pill"
              onClick={(e) => {
                e.preventDefault();
                setRelatedLink("PartyNoWiseDrat");
              }}
            >
              Party Name
            </a>
          </li>
        </ul>

        {/* --- Tab Content --- */}
        <div className="tab-content" id="drat-tabContent">
          <div
            id="pane-diary"
            role="tabpanel"
            aria-labelledby="tab-diary"
            className={`tab-pane fade ${
              relatedLink === "DiaryNoWiseDrat" ? "show active" : ""
            }`}
          >
            <DiaryNoWiseDrat />
          </div>

          <div
            id="pane-case"
            role="tabpanel"
            aria-labelledby="tab-case"
            className={`tab-pane fade ${
              relatedLink === "CaseNoWiseDrat" ? "show active" : ""
            }`}
          >
            <CaseNoWiseDrat />
          </div>

          <div
            id="pane-party"
            role="tabpanel"
            aria-labelledby="tab-party"
            className={`tab-pane fade ${
              relatedLink === "PartyNoWiseDrat" ? "show active" : ""
            }`}
          >
            <PartyNoWiseDrat />
          </div>
        </div>
      </div>
    </>
  );
};

export default DratCaseStatusParent;
